import { useMutation, useQueryClient } from "@tanstack/react-query";
import { refundInvoiceAction } from "../actions/refundInvoice";
import type { IRefundInvoicePayload } from "../../create/interfaces/invoice.interfaces";
import { useSelector } from "react-redux";
import { invalidateAfterInvoiceChange } from "../utils/invoiceQueryInvalidation";

export const useRefundInvoiceMutation = () => {
  const queryClient = useQueryClient();
  const company = useSelector((state: any) => state.userState?.company);

  return useMutation({
    mutationFn: ({
      invoiceUid,
      payload,
    }: {
      invoiceUid: string;
      payload?: IRefundInvoicePayload;
      billingJobEventUids?: string[];
      extraInvalidateJobEventUids?: string[];
      quoteId?: number | null;
    }) => {
      if (!company?.id) {
        throw new Error("Company ID is required");
      }
      return refundInvoiceAction(invoiceUid, company.id, payload);
    },
    onSuccess: (_data, variables) => {
      const jobEventUids = Array.from(
        new Set([
          ...(variables.billingJobEventUids ?? []),
          ...(variables.extraInvalidateJobEventUids ?? []),
        ]),
      );
      invalidateAfterInvoiceChange(queryClient, {
        invoiceUid: variables.invoiceUid,
        jobEventUids,
        quoteId: variables.quoteId,
      });
    },
  });
};
